import { ThunkAction } from '../../store/types'
import * as actions from './actions'
import axios from 'axios'
import { finishLoading, startLoading } from '../loading/actions'

export const fetchPatients = (
  size?: number,
  page?: number,
  text?: string
): ThunkAction => {
  return async dispatch => {
    // @ts-ignore
    dispatch(actions.fetchPatientsRequest())
    // @ts-ignore
    dispatch(startLoading())
    try {
      // const resp = await axios.get('/patients')
      // const res = await axios.get('/users/lists?size=9&page=0')
      let res
      if (text) {
        res = await axios.get(`/users/lists?size=${size}&page=${page}&firstName=${text}`)
      } else if (size && page) {
        res = await axios.get(`/users/lists?size=${size}&page=${page}`)
      } else if (size) {
        res = await axios.get(`/users/lists?size=${size}`)
      } else {
        res = await axios.get('/users/lists')
      }
      // @ts-ignore
      dispatch(actions.fetchPatientsSuccess(res.data))
      // @ts-ignore
      dispatch(finishLoading())
    } catch (err) {
      // @ts-ignore
      dispatch(actions.fetchPatientsFail(err))
      // @ts-ignore
      dispatch(finishLoading())
    }
  }
}

export const fetchPatient = (id: string): ThunkAction => {
  return async dispatch => {
    // @ts-ignore
    dispatch(actions.fetchPatientRequest())

    try {
      const resp = await axios.get(`/users/${id}`)
      // @ts-ignore
      dispatch(actions.fetchPatientSuccess(resp.data))
    } catch (err) {
      // @ts-ignore
      dispatch(actions.fetchPatientFail(err))
    }
  }
}

export const fetchPatientsEstimations = (id: string): ThunkAction => {
  return async dispatch => {
    // @ts-ignore
    dispatch(actions.fetchPatientsEstimationsRequest())

    try {
      const resp = await axios.get(`/users/${id}/estimations`)
      // @ts-ignore
      dispatch(actions.fetchPatientsEstimationsSuccess(resp.data))
    } catch (err) {
      // @ts-ignore
      dispatch(actions.fetchPatientsEstimationsFail(err))
    }
  }
}

export const deleteUser = (id: string): ThunkAction => {
  return async dispatch => {
    // @ts-ignore
    dispatch(actions.deleteUserRequest())

    try {
      await axios.delete(`/users/${id}`)
      // @ts-ignore
      dispatch(actions.deleteUserSuccess())
    } catch (err) {
      // @ts-ignore
      dispatch(actions.deleteUserFail(err))
    }
  }
}

export const resetUserPassword = (id: string): ThunkAction => {
  return async dispatch => {
    // @ts-ignore
    dispatch(actions.resetUserPasswordRequest())

    try {
      await axios.post(`/users/${id}/password`)
      // @ts-ignore
      dispatch(actions.resetUserPasswordSuccess())
    } catch (err) {
      // @ts-ignore
      dispatch(actions.resetUserPasswordFail(err))
    }
  }
}
